<div class="testimonial__area grey-bg pt-95 pb-95">
  <div class="container custom-container-2">
      <div class="row">
          <div class="col-lg-12">
              <div class="row">
                  <div class="col-xl-12">
                      <div class="section__wrapper text-center mb-40">
                          <h3 class="section__title-2">FEATURED PRODUCTS</h3>
                          <p class="sub-title">Commodo sociosqu venenatis cras dolor sagittis integer luctus sem primis eget maecenas sed urna malesuada consectetuer</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-lg-12">
              <div class="testimonial__slider-active swiper-container">
                <div class="swiper-wrapper">
                  <div *ngFor="let item of testimonial_data" class="testimonail__slider-item swiper-slide">
                      <div class="testimonial__image text-center mb-50">
                          <img [src]="item.img" alt="user">
                      </div>
                      <div class="testimonial__content">
                          <p>{{item.desc}}</p>
                      </div>
                  </div>
                </div>
                <div class="tp-testi-dot"></div>
              </div>
          </div>
      </div>
  </div>
</div>
